<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div style="min-width: 200px">
        <v-tabs v-model="tab" grow class="tab-btn-style">
          <v-tab class="c-tab" v-if="permitObj.upComingClasses">Upcoming Classes</v-tab>
          <v-tab class="c-tab" v-if="permitObj.completedClasses">Completed Classes</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item v-if="permitObj.upComingClasses">
          <class-table></class-table>
        </v-tab-item>
        <v-tab-item v-if="permitObj.completedClasses">
          <past-classes-table></past-classes-table>
        </v-tab-item>
        
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import ClassTable from "../../../components/TutorPanel/classes/ClassTable.vue";
import PastClassesTable from "../../../components/TutorPanel/classes/PastClassesTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "Classes",
  components: { ClassTable, BreadCrumbs,PastClassesTable },
  data() {
    return {
      tab: null,
      permitObj : {} ,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name
          }
        }
      ]
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "TutorClasses";
      this.permitObj = getPermitObjects(links, pathName);
    }
  },
  mounted() {
    this.getPermittedArray();
  },
};
</script>

<style scoped>
</style>